(function () {
  const SELECTOR = '[data-sl-trust-icons]';

  function waitForGsap(callback) {
    if (window.gsap && window.ScrollTrigger) {
      callback();
      return;
    }

    window.setTimeout(() => waitForGsap(callback), 120);
  }

  function refreshTriggers(state) {
    if (!window.ScrollTrigger) return;

    window.ScrollTrigger.refresh();
    state.headingTween?.scrollTrigger?.update();
    state.pinTimeline?.scrollTrigger?.update();
  }

  function clearAnimations(section, state) {
    state.headingTween?.scrollTrigger?.kill();
    state.headingTween?.kill();
    state.pinTimeline?.scrollTrigger?.kill();
    state.pinTimeline?.kill();

    if (window.gsap) {
      window.gsap.set(
        [state.media, state.foreground, state.heading, ...state.cards].filter(Boolean),
        { clearProps: 'all' }
      );
    }

    section.classList.remove('is-enhanced');
  }

  function buildAnimations(section, state) {
    clearAnimations(section, state);

    if (window.innerWidth <= 767) {
      return;
    }

    section.classList.add('is-enhanced');

    window.gsap.set(state.media, { yPercent: -8, scale: 1.03 });
    window.gsap.set(state.foreground, { y: 0 });

    if (state.heading) {
      window.gsap.set(state.heading, { autoAlpha: 0, y: 48 });

      state.headingTween = window.gsap.to(state.heading, {
        autoAlpha: 1,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: state.stage,
          start: 'top center',
          end: 'top top',
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    }

    if (state.cards.length) {
      window.gsap.set(state.cards, { autoAlpha: 0, y: 56 });
    }

    state.pinTimeline = window.gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: state.panel,
        start: 'top top',
        end: '+=90%',
        scrub: 0.8,
        pin: true,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true
      }
    });

    state.pinTimeline
      .to(state.media, { yPercent: 10, scale: 1.08 }, 0)
      .to(state.foreground, { y: -12 }, 0);

    if (state.heading) {
      state.pinTimeline.to(state.heading, { y: 32 }, 0.1);
    }

    if (state.cards.length) {
      state.pinTimeline.to(
        state.cards,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.42,
          stagger: 0.08
        },
        0.2
      );
    }

    window.requestAnimationFrame(() => {
      refreshTriggers(state);
    });
  }

  function destroySection(section) {
    const state = section.__slTrustState;
    if (!state) return;

    window.removeEventListener('resize', state.onResize);
    window.removeEventListener('load', state.onLoad);
    window.removeEventListener('pageshow', state.onLoad);

    if (state.resizeFrame) {
      window.cancelAnimationFrame(state.resizeFrame);
    }

    clearAnimations(section, state);
    delete section.__slTrustState;
  }

  function initSection(section) {
    if (section.__slTrustState) return;

    const state = {
      stage: section.querySelector('[data-sl-trust-stage]'),
      panel: section.querySelector('[data-sl-trust-panel]'),
      media: section.querySelector('[data-sl-trust-media]'),
      foreground: section.querySelector('[data-sl-trust-foreground]'),
      heading: section.querySelector('[data-sl-trust-heading]'),
      cards: Array.from(section.querySelectorAll('[data-sl-trust-card]')),
      headingTween: null,
      pinTimeline: null,
      resizeFrame: null,
      onResize: null,
      onLoad: null
    };

    if (!state.stage || !state.panel || !state.media || !state.foreground) return;

    section.__slTrustState = state;

    waitForGsap(() => {
      if (!section.isConnected || !section.__slTrustState) return;

      window.gsap.registerPlugin(window.ScrollTrigger);

      state.onResize = () => {
        if (state.resizeFrame) {
          window.cancelAnimationFrame(state.resizeFrame);
        }

        state.resizeFrame = window.requestAnimationFrame(() => {
          state.resizeFrame = null;
          buildAnimations(section, state);
        });
      };
      state.onLoad = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            if (!section.isConnected || !section.__slTrustState) return;
            buildAnimations(section, state);
          });
        });
      };

      window.addEventListener('resize', state.onResize);
      window.addEventListener('load', state.onLoad);
      window.addEventListener('pageshow', state.onLoad);

      state.onLoad();
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.(SELECTOR) || event.target;
    if (section?.matches?.(SELECTOR)) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target?.querySelector?.(SELECTOR) || event.target;
    if (section?.matches?.(SELECTOR)) destroySection(section);
  });
})();
